export default [
  {
    title: "Dashboard",
    customIcon: "DataManageSVG",
    children: [
      {
        title: "Overview Performance",
        route: "custom-module",
        path: "/custom-module/overviewperformance",
      },
      {
        title: "Selling Performance",
        route: "custom-module",
        path: "/custom-module/sellingperformance",
      },
    ],
  },
];
